type ApexChartContext = {
  w?: {
    globals?: {
      labels?: string[]
      categoryLabels?: string[]
      tooltip?: {hideTooltip?: () => void}
    }
  }
}

type ApexClickConfig = {dataPointIndex: number}

export type ChartPointClickHandler = (
  label: string,
  value: number,
  index: number
) => void

export function parseChartNumericValue(raw: unknown): number {
  const normalized = String(raw ?? 0).replace(',', '.')
  const value = Number(normalized)
  return Number.isFinite(value) ? value : 0
}

export function formatDurasiJam(value: string | number | undefined): string {
  if (value === undefined || value === null || value === '') return '-'

  if (typeof value === 'string' && /jam|menit|detik/i.test(value)) {
    return value
  }

  const hours = Number(String(value).replace(',', '.'))
  if (!Number.isFinite(hours) || hours < 0) return '-'
  if (hours === 0) return '0 detik'

  const totalSeconds = Math.round(hours * 3600)
  const jam = Math.floor(totalSeconds / 3600)
  const menit = Math.floor((totalSeconds % 3600) / 60)
  const detik = totalSeconds % 60

  const parts: string[] = []
  if (jam > 0) parts.push(`${jam} jam`)
  if (menit > 0) parts.push(`${menit} menit`)
  if (detik > 0 || parts.length === 0) parts.push(`${detik} detik`)

  return parts.join(' ')
}

export function resolveChartPointLabel(
  chartContext: ApexChartContext,
  dataPointIndex: number,
  categories: unknown[]
): string {
  const globals = chartContext?.w?.globals
  const label =
    categories?.[dataPointIndex] ??
    globals?.categoryLabels?.[dataPointIndex] ??
    globals?.labels?.[dataPointIndex]
  return label != null ? String(label) : ''
}

export function fireChartPointClick(
  chartContext: ApexChartContext,
  config: ApexClickConfig,
  categories: unknown[],
  seriesData: unknown[] | undefined,
  onPointClick?: ChartPointClickHandler
) {
  if (!onPointClick || config.dataPointIndex < 0) {
    return
  }
  const index = config.dataPointIndex
  const label = resolveChartPointLabel(chartContext, index, categories)
  const value = parseChartNumericValue(seriesData?.[index])
  chartContext?.w?.globals?.tooltip?.hideTooltip?.()
  setTimeout(() => onPointClick(label, value, index), 0)
}

export function buildChartClickEvents(
  categories: unknown[],
  seriesData: unknown[] | undefined,
  onPointClick?: ChartPointClickHandler
) {
  const handlePointClick = (
    _event: unknown,
    chartContext: ApexChartContext,
    config: ApexClickConfig
  ) => fireChartPointClick(chartContext, config, categories, seriesData, onPointClick)

  return {
    click: handlePointClick,
    markerClick: handlePointClick,
  }
}
